export const roleDropDownList = [
  { name: 'Dentist', status: true },
  { name: 'Dental Assistant', status: false }
];

export const pmsDropDownList = [
  { name: 'Eaglesoft' },
  { name: 'Dentrix' },
  { name: 'OpenDental' }
];

export enum ERROR_TYPES {
  UNAUTHORIZED = 'Unauthorized',
  INVALID_SESSION = 'Session expired. Please login again.',
  INVALID_OTP = 'Please enter the valid code.'
}

export const REASON_LIST = [
  { key: 'too_expensive', value: 'It’s too expensive' },
  { key: 'missing_features', value: 'Some features are missing' },
  { key: 'switched_service', value: 'I’m switching to a different service' },
  { key: 'unused', value: 'I don’t use the service enough' },
  { key: 'customer_service', value: 'Customer service was less than expected' },
  { key: 'too_complex', value: 'Ease of use was less than expected' },
  { key: 'low_quality', value: 'Quality was less than expected' },
  { key: 'other', value: 'Other reason' }
];

export const ERROR_MESSAGE = {
  CARDHOLDER_NAME_REQ: 'Cardholder name is required.',
  somethingWentWrong: 'Something went wrong, Please try again.',
  addressOneRequired: 'Address Line 1 is required.',
  addressTwoRequired: 'Address Line 2 is required.',
  suitePlaceholder: 'e.g., Suite 201, Ste 105',
  officeIdRequired: 'Office Id is required.',
  cityRequired: 'City is required.',
  stateRequired: 'State is required.',
  countryRequired: 'Country is required.',
  zipCodeRequired: 'Zip code is required.',
  requiredFieldMsg: 'Please enter valid information in required fields',
  passwordErrormsg: `Password must be at least 8 characters long and include at least one letter, one number, and one special character. Allowed special characters are: @ $ ! % # ? & " ' ( ) * + , - . / : ; < = > [ \ ] ^ _ \` { | } ~ ÷ € £ ¥ • ₹ × ¿ ¡ °`,
  confPasswordErrormsg: 'Passwords do not match. Please retry.',
  nameErrormsg: 'Allow alphabets only.',
  numberErrormsg: 'Allow numerics only.',
  emailErrorMsg: 'Please enter a valid email.',
  mobileErrorMsg: 'Please enter a valid phone number.',
  mobileFormatErrorMsg: 'Please enter a valid country code and phone number.',
  emailRequiredMsg: 'Username is required.',
  phoneRequiredMsg: 'Phone number is required.',
  secondaryPhoneRequiredMsg: 'Secondary phone number is required.',
  passwordRequiredMsg: 'Password is required.',
  newPasswordRequiredMsg: 'New password is required.',
  firstNameRequiredMsg: 'First name is required.',
  nameRequiredMsg: 'Name is required.',
  lastNameRequiredMsg: 'Last name is required.',
  confPasswordRequiredMsg: 'Confirm password is required.',
  licenseNumberRequiredMsg: 'License number  is required.',
  cardHolderRequiredMsg: 'Cardholder name  is required.',
  userAlreadyExists: 'User with email id already exists.',
  offlineError: 'Please check your internet connection',
  ROLE_NAME_REQ: 'Role Name is required.',
  PERMISSION_NAME_REQ: 'Permission name is required.',
  DISTINCT_EMAILS_REQ: 'Primary and secondary emails should be different.',
  DISTINCT_PHONE_NO_REQ:
    'Primary and secondary phone numbers should be different.'
};

export const AGREEMENTLICENSE = {
  agreementTitle: 'End-User License Agreement (EULA)',
  agreementDesc:
    'Please read this EULA carefully before using the DentScribe software. By using the software, you are agreeing to be bound by the terms of this EULA ',
  RestrictionsUseTitle: 'Restrictions on Use',
  RestrictionsUseDesc:
    'You may not reproduce, distribute, display, modify, or create derivative works based on the DentScribe software without prior written consent from Medisync.ai.',
  OwnershipandCopyrightTitle: 'Ownership and Copyright',
  OwnershipandCopyrightDesc:
    'The DentScribe software is owned by Medisync.ai and its licensors and is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties.',
  GrantofLicenseTitle: 'Grant of License',
  GrantofLicenseDesc:
    'This EULA grants you a limited, non-exclusive, non-transferable, and revocable license to use the DentScribe software for your personal use only.',
  EntireAgreementTitle: 'Entire Agreement',
  EntireAgreementDesc:
    'This EULA constitutes the entire agreement between you and Medisync.ai and supersedes all prior agreements or understandings, whether written or oral, regarding the DentScribe software.',
  PrivacyPolicyTitle: 'Privacy Policy',
  PrivacyPolicyDesc:
    'You acknowledge that your use of the DentScribe software is subject to our Privacy Policy, which is available on our website and may be updated from time to time.',
  DisclaimerWarrantiesTitle: 'Disclaimer of Warranties',
  DisclaimerWarrantiesDesc:
    'The DentScribe software is provided “as is” without any express or implied warranty of any kind, including warranties of merchantability or fitness for any particular purpose.',
  limitationofLiabilityTitle: 'Limitation of Liability',
  limitationofLiabilityDesc:
    'In no event shall Medisync.ai be liable for any damages (including, without limitation, damages for loss of business profits, business interruption, loss of business information, or any other pecuniary loss) arising out of the use or inability to use the DentScribe software.',
  terminationTitle: 'Termination',
  terminationDesc:
    'This EULA will terminate automatically if you fail to comply with any of the terms and conditions of this EULA. Upon termination, you must immediately cease all use of the DentScribe software and destroy all copies of the software.',
  governingLawTitle: 'Governing Law',
  governingLawDesc:
    'This EULA shall be governed by and construed in accordance with the laws of the state of California, without giving effect to any principles of conflicts of law.'
};

export const US_STATE = [
  {
    name: 'Alabama',
    isoCode: 'AL',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Alaska',
    isoCode: 'AK',
    countryCode: 'US',
    status: false
  },
  {
    name: 'American Samoa',
    isoCode: 'AS',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Arizona',
    isoCode: 'AZ',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Arkansas',
    isoCode: 'AR',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Baker Island',
    isoCode: 'UM-81',
    countryCode: 'US',
    status: false
  },
  {
    name: 'California',
    isoCode: 'CA',
    countryCode: 'US',
    status: true
  },
  {
    name: 'Colorado',
    isoCode: 'CO',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Connecticut',
    isoCode: 'CT',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Delaware',
    isoCode: 'DE',
    countryCode: 'US',
    status: false
  },
  {
    name: 'District of Columbia',
    isoCode: 'DC',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Florida',
    isoCode: 'FL',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Georgia',
    isoCode: 'GA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Guam',
    isoCode: 'GU',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Hawaii',
    isoCode: 'HI',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Howland Island',
    isoCode: 'UM-84',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Idaho',
    isoCode: 'ID',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Illinois',
    isoCode: 'IL',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Indiana',
    isoCode: 'IN',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Iowa',
    isoCode: 'IA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Jarvis Island',
    isoCode: 'UM-86',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Johnston Atoll',
    isoCode: 'UM-67',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Kansas',
    isoCode: 'KS',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Kentucky',
    isoCode: 'KY',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Kingman Reef',
    isoCode: 'UM-89',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Louisiana',
    isoCode: 'LA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Maine',
    isoCode: 'ME',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Maryland',
    isoCode: 'MD',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Massachusetts',
    isoCode: 'MA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Michigan',
    isoCode: 'MI',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Midway Atoll',
    isoCode: 'UM-71',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Minnesota',
    isoCode: 'MN',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Mississippi',
    isoCode: 'MS',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Missouri',
    isoCode: 'MO',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Montana',
    isoCode: 'MT',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Navassa Island',
    isoCode: 'UM-76',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Nebraska',
    isoCode: 'NE',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Nevada',
    isoCode: 'NV',
    countryCode: 'US',
    status: false
  },
  {
    name: 'New Hampshire',
    isoCode: 'NH',
    countryCode: 'US',
    status: false
  },
  {
    name: 'New Jersey',
    isoCode: 'NJ',
    countryCode: 'US',
    status: false
  },
  {
    name: 'New Mexico',
    isoCode: 'NM',
    countryCode: 'US',
    status: false
  },
  {
    name: 'New York',
    isoCode: 'NY',
    countryCode: 'US',
    status: false
  },
  {
    name: 'North Carolina',
    isoCode: 'NC',
    countryCode: 'US',
    status: false
  },
  {
    name: 'North Dakota',
    isoCode: 'ND',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Northern Mariana Islands',
    isoCode: 'MP',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Ohio',
    isoCode: 'OH',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Oklahoma',
    isoCode: 'OK',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Oregon',
    isoCode: 'OR',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Palmyra Atoll',
    isoCode: 'UM-95',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Pennsylvania',
    isoCode: 'PA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Puerto Rico',
    isoCode: 'PR',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Rhode Island',
    isoCode: 'RI',
    countryCode: 'US',
    status: false
  },
  {
    name: 'South Carolina',
    isoCode: 'SC',
    countryCode: 'US',
    status: false
  },
  {
    name: 'South Dakota',
    isoCode: 'SD',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Tennessee',
    isoCode: 'TN',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Texas',
    isoCode: 'TX',
    countryCode: 'US',
    status: false
  },
  {
    name: 'United States Minor Outlying Islands',
    isoCode: 'UM',
    countryCode: 'US',
    status: false
  },
  {
    name: 'United States Virgin Islands',
    isoCode: 'VI',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Utah',
    isoCode: 'UT',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Vermont',
    isoCode: 'VT',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Virginia',
    isoCode: 'VA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Wake Island',
    isoCode: 'UM-79',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Washington',
    isoCode: 'WA',
    countryCode: 'US',
    status: false
  },
  {
    name: 'West Virginia',
    isoCode: 'WV',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Wisconsin',
    isoCode: 'WI',
    countryCode: 'US',
    status: false
  },
  {
    name: 'Wyoming',
    isoCode: 'WY',
    countryCode: 'US',
    status: false
  }
];

export const COUNTRY = [{ name: 'United States', status: false }];

export enum PAGES {
  LOGIN = '/login'
}

export enum TOAST_TYPE {
  SUCCESS = 'success',
  ERROR = 'error'
}

export const PAYMENT_SUCCEEDED = 'succeeded';

export enum INSTRUCTIONS {
  SECURITY_CODE = 'We will send a security code to this email for verification',
  PRACTICE_COMMON_EMAIL = 'You can receive After Care Summary report on this email by enabling from app settings.'
}

export const TRIAL_USER_SUBSCRIPTION = {
  tier: 'Free (14 days trial)',
  creditCardRequired: false,
  description:
    'Unlimited SOAP Note Generation\nPractice Management Software Integration\nEdit and Review SOAP Notes on the Go'
};
